import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for first-page exhibit insertion. */
export const firstPageExhibitElement: ElementDefinition = {
  id: 'first-page-exhibit',
  label: 'Graph First Page',
  icon: 'DocumentPageNumberRegular',
  description: 'First-page stacked graph layout',
  category: 'exhibit',
  templateIds: ['base'],
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('first-page', profile);
  },
};

/** Toolbar action for first-page exhibit insertion. */
export async function insertGraphFirstPageLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('first-page', profile);
}
